import { define } from 'wicked-elements'

define('[data-component~="menu"]', {
  init () {
    this.open = false
    this.$button = this.element.querySelector('button')
    this.$nav = this.element.querySelector('nav')
  },
  connected () {
    this.$button.onclick = () => {
      this.open = !this.open
      if (this.open) {
        this.$nav.classList.remove('hidden')
        this.$button.classList.replace('menu--open', 'menu--close')
      } else {
        this.$nav.classList.add('hidden')
        this.$button.classList.replace('menu--close', 'menu--open')
      }
    }
  }
})